import { Table as MUITable, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import styles from '@styles/components/FrequencyTable.module.css';
import '@styles/components/GlobalCSSTableOverrides.css';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { TableVirtuoso } from 'react-virtuoso';

import { ReactComponent as FilterSVg } from '@assets/SVGs/GeneralUse/Filter.svg';
import designSystem from '@styles/designSystem';

/* 
    rowTemplate is a function that returns a React element. It is called for each row in the table.
*/

const ColumnWithFilter = ({ column }) => {
    const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClickOnFilter = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen((previousOpen) => !previousOpen);
    };

    return (
        <TableCell
            key={column.dataKey}
            variant="head"
            align={'center'}
            sx={[{ backgroundColor: designSystem.colorBackgroundGray2, ...column.style }, column.size && { width: column.size, maxWidth: column.size }]}
            style={{
                fontFamily: designSystem.fontFamily, fontWeight: designSystem.fontWeightDropdownText
            }}
        >
            <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                {column.label}
                <div className={styles['filter-container']} onClick={handleClickOnFilter}>
                    <FilterSVg />
                    {open && <column.component {...column.componentProps} isOpen={open} anchorElement={anchorEl} clickAwayHandler={() => setOpen(false)} />}
                </div>

            </div>
        </TableCell>
    )
}

const Column = ({ column }) => {
    return (
        <TableCell
            key={column.dataKey}
            variant="head"
            align={'center'}
            sx={[{ backgroundColor: designSystem.colorBackgroundGray2, ...column.style }, column.size && { width: column.size, maxWidth: column.size }]}
            style={{
                fontFamily: designSystem.fontFamily, fontWeight: designSystem.fontWeightDropdownText
            }}
        >
            {column.label}
        </TableCell>
    )
}

const Table = ({ loading, dataForRows, columns, rowTemplate, placeHolder = 'No hay información'.localized() }) => {

    const VirtuosoTableComponents = {
        Scroller: React.forwardRef((props, ref) => (
            <TableContainer component={Paper} {...props} ref={ref} />
        )),
        Table: (props) => (
            <MUITable {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
        ),
        TableHead,
        TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
        TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
        EmptyPlaceholder: () => {
            return (!loading &&
                <TableBody>
                    <TableRow>
                        <TableCell style={{ borderBottom: '0px' }}>
                            <div className={styles['no-rows-text']} style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                textAlign: 'center',
                                fontFamily: designSystem.fontFamily,
                                fontWeight: 700,
                                fontSize: '1.5rem',
                                color: '#c4c3c3',
                            }}>
                                {placeHolder}
                            </div>
                        </TableCell>
                    </TableRow>
                </TableBody>
            );
        },
    };

    function fixedHeaderContent() {
        return (
            <TableRow>
                {columns.map((column) => (
                    !column.component ?
                        <Column column={column} /> :
                        <ColumnWithFilter column={column} />
                ))}
            </TableRow>
        );
    }


    const [rows, setRows] = useState([])

    useEffect(() => {
        if (dataForRows) {
            setRows(dataForRows)
        } else {
            setRows([])
        }
    }, [dataForRows])


    return (
        <Paper sx={{
            height: '100%',
            width: '100%',
        }} elevation={0}>
            <TableVirtuoso
                data={rows}
                components={VirtuosoTableComponents}
                fixedHeaderContent={fixedHeaderContent}
                itemContent={loading ? () => <div style={{ height: '1px' }} /> : rowTemplate}
                className={loading ? styles['skeleton'] : ''}
                style={{ 
                    height: '100%',
                    width: '100%',
                    borderTopLeftRadius: designSystem.cornerRadiusComponent, 
                    borderTopRightRadius: designSystem.cornerRadiusComponent 
                }}
            />
        </Paper>
    );
}

export default Table